import { createApiRequest } from "../common";
import { AcceptOrgInviteRequestContent, AcceptOrgInviteResponseContent } from '@equaliq/api-model-v2';

export const acceptOrgInviteApi = async (request: AcceptOrgInviteRequestContent): Promise<AcceptOrgInviteResponseContent> => {
  const apiRequest = createApiRequest<AcceptOrgInviteResponseContent>('post', '/orgs/invites/accept');
  return apiRequest(request);
};